import script from "./AddEventView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddEventView.vue?vue&type=script&setup=true&lang=ts"

import "./AddEventView.vue?vue&type=style&index=0&id=d355a1fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d355a1fa"]])

export default __exports__